import { format, distanceInWordsToNow } from 'date-fns';
import { Decimal } from 'decimal.js';


// Date formatters
export const relativeDate = (dt: Date) => {
  return dt ? distanceInWordsToNow(dt) : '';
};

export const timeStamp = (dt: Date) => {
  return dt ? format(dt, 'MM/DD/YYYY HH:mm') : '';
};

export const date = (dt: Date) => {
  return dt ? format(dt, 'MM/DD/YYYY') : '';
};

// Currency formatters
export const currency = (amount: Decimal, ts=',', ds='.') => {
  if (!amount) {
    return '';
  }

  const arr = amount.toFixed(2).split(".");
  arr[0] = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
  return arr.join(ds);
};
